import {SEARCH_FILTERS} from '@/src/app/constants/search';
import FilterByOrder from '@/src/jobPortal/clinicPositions/components/FilterByOrder';
import FilterByStatus from '@/src/jobPortal/clinicPositions/components/FilterByStatus';
import {jopPositionsFilterProps} from '@/src/jobPortal/clinicPositions/hooks/useClinicPositions';
import css from '@/src/jobPortal/clinicPositions/styles/filters.module.css';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Text} from '@/src/ui';

import SimpleCollapse from '../../../ui/Collapse/components/SimpleCollapse';

interface ClinicPositionsFilterLayoutProps {
  onFilterChange: Function;
  filter: jopPositionsFilterProps;
}

const ClinicPositionsFilterLayout = ({
  onFilterChange,
  filter,
}: ClinicPositionsFilterLayoutProps) => {
  return (
    <div>
      <div className={css.filterGroupWrapper}>
        <SimpleCollapse
          headTitle={
            <Text
              fontWeight={Text.FONT_WEIGHT.MEDIUM}
              fontSize={Text.FONT_SIZE.SIZE_16}
            >
              <TextLocal id={'search.statuses'} />
            </Text>
          }
          defaultIsOpen
        >
          <FilterByStatus
            onChange={onFilterChange}
            selectedStatus={filter[SEARCH_FILTERS.FILTERS_STATUS]}
          />
        </SimpleCollapse>
      </div>
      <div className={css.filterGroupWrapper}>
        <SimpleCollapse
          headTitle={
            <Text
              fontWeight={Text.FONT_WEIGHT.MEDIUM}
              fontSize={Text.FONT_SIZE.SIZE_16}
            >
              <TextLocal id={'search.sorting'} />
            </Text>
          }
          defaultIsOpen
        >
          <FilterByOrder
            onChange={onFilterChange}
            selectedOrder={filter[SEARCH_FILTERS.ORDER]}
          />
        </SimpleCollapse>
      </div>
    </div>
  );
};

export default ClinicPositionsFilterLayout;
